import Swiper, { Pagination, EffectFade, Autoplay, A11y } from 'swiper'
// Swiper.use([Pagination, EffectFade, Autoplay, A11y])

const swiperBannerRedesign = () => {

	const swiper = document.querySelectorAll('[data-banner-redesign-swiper]')

	if (!swiper) return false

	let bullets = document.querySelectorAll('.swiper-pagination-bullet')

	let carousel = new Swiper('[data-banner-redesign-swiper]', {
		effect: "fade",
		autoHeight: true,
		speed: 1000,
		fadeEffect: {
			crossFade: true,
		},
		loop: true,
		on: {
			slideChange: function () {
				bullets.forEach((bullet, idx) => {
					bullet.classList.toggle('swiper-pagination-bullet-active', idx === this.realIndex)
				})
			}
		}
	})

	bullets.forEach((bullet, idx) => {
		bullet.addEventListener('click', () => {
			carousel.slideToLoop(idx)
		})
	})

}

export default swiperBannerRedesign
